import { defineComponent as _defineComponent } from 'vue'
import Popup from '@xt/client/mixins/components/groupbuy/groupPopup/groupPopupPc.vue'
import { useModal } from 'vue-nice-modal'
import { PropType, ref } from 'vue'
import type { GroupPopupProps } from '@xt/client/utils/messageModalQueue/types'
import { EnumModalOpStatus } from '@xt/client/enums/messageModalQueue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  dataSource: {
    required: true,
    type: Object as PropType<GroupPopupProps>
  }
},
  setup(__props) {

const props = __props;

const modal = useModal() // hook 在 wrapper 中使用


const mainHandler = () => {
  modal.resolve({
    status: EnumModalOpStatus.Ok
  })
  modal.hide()
}

const viceHandler = () => {
  modal.resolve({
    status: EnumModalOpStatus.Cancel
  })
  modal.hide()
}

const onClose = () => {
  modal.resolve({
    status: EnumModalOpStatus.Close
  })
  modal.hide()
}

return { __sfc: true,modal, props, mainHandler, viceHandler, onClose, Popup }
}

})